function whichAnimationEvent(){
  var t,
      el = document.createElement("fakeelement");

  var animations = {
    "animation"      : "animationend",
    "OAnimation"     : "oAnimationEnd",
    "MozAnimation"   : "animationend",
    "WebkitAnimation": "webkitAnimationEnd"
  }

  for (t in animations){
    if (el.style[t] !== undefined){
      return animations[t];
    }
  }
}

var animationEvent = whichAnimationEvent();

$.fn.animateCSS = function( options ) {
  var self = this;
  var set = $.extend({
    delay: 0,
    stepDelay: 200,
    style: 'fadeInUp',
    waitFor: null,
    revert: false,
    removeStyle: false,
    before: function() {},
    after: function() {}
  }, options);

  function setDelay(item, index) {
    setTimeout(function(){
      $(item)
        .addClass('animated ' + set.style);

      if (set.removeStyle) {
        $(item).one(animationEvent, function() {
          $(this).removeClass(set.style);
        })
      }
    }, set.delay + (index * set.stepDelay));
  }

  // function getLast(el, index) {
  //   var len = $(el).length;
  //   if ( index === len - 1 ) {
  //     console.log($(el));
  //     setTimeout(function(){
  //       $(el).one(animationEvent, function(){
  //         set.after();
  //       })
  //     }, set.delay)
  //   }
  // }

  function animate(el) {
    set.before(el);
    var $el = $(el);
    var len = $el.length;

    if ( set.revert ) {
      $($el.get().reverse()).each(function(i){
        setDelay(this, i);
      });
    } else {
      $el.each(function(i){
        var self = this;
        setDelay(self, i);

        // just last item in row
        if ( i === len - 1 ) {
          setTimeout(function(){
            $(self).one(animationEvent, function(){
              set.after();
            });
          },set.delay);
        }
      });
    }
  }

  if ( set.waitFor !== null ) {
    $(set.waitFor).one(animationEvent, function(){
      return animate(self);
    });
  } else {
    return animate(self);
  }
};
